export const APPLICATION_JSON_DETAILED = 'application/json*detailed';
